// extracted by mini-css-extract-plugin
module.exports = {"viewers":"Viewers_viewers__3tCkR","header":"Viewers_header__1zBV9","headerText":"Viewers_headerText__16iY0","elements":"Viewers_elements__1NhVs"};